const HamburgerIcon = ({ toggleNav }) => {
    return (
        <i className="fa-solid fa-bars" onClick={toggleNav}></i>
    );
}
export default HamburgerIcon;